import { useEffect, useState, useRef } from 'react'
import Layout from '../../components/Layout'
import { getCookie, isAuth, setCookie } from '../../helpers/helpers'
import axios from "axios"
import 'react-toastify/dist/ReactToastify.css'
import { ToastContainer, toast } from 'react-toastify'
import { defaultOptions, FreeVersion, UnpaidInvoices, UserMessage, formatIsoString, roundDigits, Button, hideGroup, hideGame, Disclamer, invalidGame, Options, NothingFound, Bonuses, Instagram, NewBookies } from './helpers'
import ClipLoader from "react-spinners/ClipLoader";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { BiLineChart, BiHide, BiRefresh, BiDotsHorizontalRounded } from 'react-icons/bi'
import { MdLink, MdLinkOff, MdClose, MdDeleteForever, MdOutlineEditOff, MdOutlineEdit, MdPhotoSizeSelectLarge, MdInfoOutline } from 'react-icons/md'
import { RiEmotionSadLine } from 'react-icons/ri'
import { LuWallet } from 'react-icons/lu'
import { createBets } from '../BetTracker/helpers'
import { FaStar } from "react-icons/fa";
import { GoDotFill } from "react-icons/go";
import cookie from 'js-cookie'
import Modal from 'react-bootstrap/Modal';
import { jwtDecode } from 'jwt-decode';
import { FaInstagram } from "react-icons/fa";
import OnboardingBanner from './NewBanner';

const colors = { 'nike': '#ff8000', 'tipsport': '#1186f0', 'fortuna': '#FFDB01', 'doxxbet': '#f40034', 'tipos': '#5033ff', 'synottip': '#e21e3a', 'bet365': '#005641', 'pinnacle': '#0e1422' }


const SmallScreen = ({ parameters }) => {
    const { arbitrages, free, unpaidInvoices, userMessage, selected, setSelected, values, membership_type, trial_end, invoices } = parameters
    const { showOptions, setShowOptions, sure, setSure, setError, addedToBetTracker, setAddedToBetTracker, options, setOptions, showAccounts, setShowAccounts, accounts, setAccounts, account1, setAccount1, account2, setAccount2, changingValues, setChangingValues, lastStake, setLastStake, linked, setLinked, value2, setValue2, value1, setValue1, stake2, setStake2, stake1, setStake1 } = values
    const [showMore, setShowMore] = useState(false)
    const [showHide, setShowHide] = useState(false)
    const [showOdds, setShowOdds] = useState(false)
    const [showInfo, setShowInfo] = useState(false)
    const navigate = useNavigate()


    useEffect(() => { setShowMore(false); setShowInfo(false) }, [selected])

    const dayNumber = invoices.length ? Math.floor((new Date().setHours(0, 0, 0, 0) - new Date(invoices.slice().sort((a, b) => new Date(b.invoice_date) - new Date(a.invoice_date))[0].invoice_date).setHours(0, 0, 0, 0)) / 86400000) + 1 : null;
    const daysLeft = Math.max(0, Math.floor((new Date(trial_end).setHours(0, 0, 0, 0) - new Date().setHours(0, 0, 0, 0)) / 86400000));


    return (
        <>
            {/* <Bonuses /> */}
            <UnpaidInvoices unpaidInvoices={unpaidInvoices} />
            <UserMessage userMessage={userMessage} />
            {/* <Instagram /> */}
            {/* <NewBookies /> */}
            <div className='row mx-sm-2 px-3 px-sm-0 gy-2'>
                <div
                    onClick={() => setShowOptions(!showOptions)}
                    className='px-3 col-auto rounded rounded-2 d-flex align-items-center justify-content-center p-0 text-secondary font1'
                    style={{ 'backgroundColor': '#222222', 'cursor': 'pointer' }}
                >Filter</div>
                <div
                    onClick={() => navigate('/profile')}
                    className='ms-2 px-3 col-auto rounded rounded-2 d-flex align-items-center justify-content-center p-0 text-secondary font1'
                    style={{
                        'backgroundColor': '#222222', 'cursor': 'pointer',
                    }}>Upozorniť
                </div>
                <a
                    href="https://instagram.com/arbitrage.sk"
                    target="_blank"

                    className='col-auto rounded rounded-2 d-flex align-items-center justify-content-center p-0 mx-2'
                    style={{
                        'width': '30px', 'height': '30px',
                        'backgroundColor': '#222222', 'cursor': 'pointer',
                        // 'backgroundImage': "url('https://preview.colorkit.co/gradient/f9ce34-ee2a7b-6228d7.png?size=wallpaper&scale=0.25&static=true')",
                        // 'backgroundSize': '100% 100%',
                        'textDecoration': 'none'
                    }}
                >
                    <FaInstagram size={'20px'} color='#6C757D' />
                </a>
                <div
                    onClick={() => navigate('/pricing')}
                    className={`${(!free) ? 'd-none' : ''} px-3 ${window.innerWidth <= 323 ? 'col-12' : 'col-auto'} me-2 rounded rounded-2 d-flex align-items-center justify-content-center p-0 text-white font-weight-bold font1 ${Math.floor((new Date(trial_end).setHours(0, 0, 0, 0) - new Date().setHours(0, 0, 0, 0)) / 86400000) > -1 && membership_type == 'free' ? 'd-none' : ''}`}
                    style={{
                        'backgroundColor': '#222222', 'cursor': 'pointer', 'height': '30px',
                        'backgroundImage': "url('https://i0.wp.com/css-tricks.com/wp-content/uploads/2020/11/css-gradient.png')",
                        'backgroundSize': '100% 100%',
                    }}>Kúpiť Plnú Verzia
                </div>
                <div
                    className={`${membership_type !== 'ultimate' ? 'd-none' : ''} px-3 ${window.innerWidth <= 323 ? 'col-12' : 'col-auto'} rounded rounded-2 d-flex align-items-center justify-content-center p-0 text-white font-weight-bold font1`}
                    style={{
                        'backgroundColor': '#222222', 'cursor': 'pointer', 'height': '30px',
                        'backgroundImage': "url('https://img.freepik.com/free-photo/artistic-blurry-colorful-wallpaper-background_58702-8664.jpg?semt=ais_hybrid&w=740&q=80')",
                        'backgroundSize': '100% 100%',
                    }}>Ultimate{dayNumber ? ` - ${dayNumber}. deň` : ''}
                </div>
                <div
                    className={`${membership_type !== 'premium' ? 'd-none' : ''} px-3 ${window.innerWidth <= 323 ? 'col-12' : 'col-auto'} rounded rounded-2 d-flex align-items-center justify-content-center p-0 text-white font-weight-bold font1`}
                    style={{
                        'backgroundColor': '#222222', 'cursor': 'pointer', 'height': '30px',
                        'backgroundImage': "url('https://img.freepik.com/premium-photo/abstract-red-background-web-design-templates-product-studio-with-smooth-gradient-color_570543-7721.jpg?semt=ais_hybrid&w=740&q=80')",
                        'backgroundSize': '100% 100%',
                    }}>Premium{dayNumber ? ` - ${dayNumber}. deň` : ''}
                </div>
                <div
                    className={`${Math.floor((new Date(trial_end).setHours(0, 0, 0, 0) - new Date().setHours(0, 0, 0, 0)) / 86400000) > -1 && membership_type == 'free' ? '' : 'd-none'} px-3 ${window.innerWidth <= 323 ? 'col-12' : 'col-auto'} rounded rounded-2 d-flex align-items-center justify-content-center p-0 text-white font-weight-bold font1`}
                    style={{
                        'backgroundColor': '#222222', 'cursor': 'pointer', 'height': '30px',
                        'backgroundImage': "url('https://img.freepik.com/premium-photo/cool-luxury-bottle-green-gradient-background_703141-6.jpg?semt=ais_hybrid&w=740&q=80')",
                        'backgroundSize': '100% 100%',
                    }}>Skúška Ultimate{daysLeft || daysLeft === 0 ? ` - ostáva ${daysLeft} dní` : ''}
                </div>

            </div>
            <Options options={options} setOptions={setOptions} showOptions={showOptions} setShowOptions={setShowOptions} />
            {/* <FreeVersion free={free} /> */}

            <OnboardingBanner invoices={invoices} />
            <NothingFound arbitrages={arbitrages} />

            {arbitrages.map(arbitrage => {
                const { offer1_data, offer2_data, offer1_gameid, offer2_gameid, offer1_start, id, group_key, roi, offer1_url, offer2_url, offer1_site, offer2_site, offer1_home, offer2_away, market, market_quantity, offer1_bet, offer2_bet, offer1_color_primary, offer2_color_primary } = arbitrage
                const start = formatIsoString(offer1_start)

                const createdAgo = (Math.abs(new Date().getTime() - new Date(arbitrage.createdAt).getTime()) / 1000).toFixed(0)
                const updatedAgo = (Math.abs(new Date().getTime() - new Date(arbitrage.updatedAt).getTime()) / 1000).toFixed(0)


                return (
                    <div
                        key={id}
                        className="mx-sm-2 mt-2 mt-sm-3 p-3 p-sm-4 rounded-4 mt-2"
                        style={{ 'backgroundColor': '#222222', 'border': `3px solid ${group_key === selected ? '#fff' : '#222222'}`, 'position': 'relative' }}
                        onClick={() => (group_key != selected && setSelected(group_key))}>
                        <div className="container-fluid">
                            {(arbitrage.offer1_is_top || arbitrage.offer2_is_top) &&
                                <span className='d-flex justify-content-center align-items-center' style={{ 'position': 'absolute', 'top': '0', 'right': '0px', 'width': '24px', 'height': '24px' }}>
                                    <GoDotFill color='#FFD700' />
                                </span>
                            }
                            {/* roi,site,name */}
                            <div className="row" style={{ 'minHeight': '50px' }}>
                                <div className="col-3 p-0 d-flex align-items-center fs-1 font1">
                                    {roi.toFixed(2)}%
                                </div>
                                <div className="col-9 d-flex flex-column justify-content-center">
                                    <div className="row ps-1 lh-sm lh-sm-base">
                                        <div className="col p-0 d-flex justify-content-center" style={{ maxWidth: '45px' }}>
                                            {['nike', 'tipsport', 'doxxbet', 'fortuna', 'synottip', 'tipos', 'bet365', 'pinnacle'].includes(offer1_site)
                                                ?
                                                <Link to={offer1_url} target="_blank" rel="noreferrer" className="d-flex align-items-center">
                                                    <img src={require(`../../static/images/sites/${offer1_site}.png`)} style={{ 'borderRadius': '2px' }} className="w-100" alt="Offer 1"></img>
                                                </Link>
                                                : <div>{offer1_site}</div>
                                            }
                                        </div>
                                        <div className="col text-truncate font1">{offer1_home}</div>
                                    </div>
                                    <div className="row ps-1 lh-sm">
                                        <div className="col p-0 d-flex justify-content-center" style={{ maxWidth: '45px' }}>
                                            {['nike', 'tipsport', 'doxxbet', 'fortuna', 'synottip', 'tipos', 'bet365', 'pinnacle'].includes(offer2_site)
                                                ?
                                                <Link to={offer2_url} target="_blank" rel="noreferrer" className="d-flex align-items-center">
                                                    <img src={require(`../../static/images/sites/${offer2_site}.png`)} style={{ 'borderRadius': '2px' }} className="w-100" alt="Offer 1"></img>
                                                </Link>
                                                : <div>{offer2_site}</div>
                                            }
                                        </div>
                                        <div className="col text-truncate font1">{offer2_away} - {updatedAgo}s</div>
                                    </div>
                                </div>
                            </div>
                            {/* start,market */}
                            <div className="row" style={{ 'minHeight': '25px' }}>
                                <div className="col-3 p-0 text-truncate">
                                    <span className="text-secondary font1">
                                        {start.dateText} {start.hour}:{start.minute}
                                    </span>
                                </div>
                                <div className="col-9 p-0 ps-1 text-truncate d-flex align-items-center">
                                    <span className="text-secondary text-uppercase font1">
                                        {market}{market_quantity}
                                    </span>
                                </div>
                            </div>
                            {/* selected */}
                            <div className={`${group_key !== selected && 'd-none'}`}>
                                {/* dividing line */}
                                <div className="row my-3">
                                    <div style={{ 'height': '3px', 'width': '100%', 'backgroundColor': '#2a2a2a' }} />
                                </div>
                                {/* bet */}
                                <div className="row">
                                    <div className="col text-center pe-0">
                                        {offer1_bet}
                                    </div>
                                    <div className="col-auto p-0" style={{ 'width': '20%' }}></div>
                                    <div className="col text-center ps-0">
                                        {offer2_bet}
                                    </div>
                                </div>
                                {/* value */}
                                <div className="row">
                                    <div className="col fs-2 text-center pe-0 font1" style={{ 'color': offer1_color_primary }}>
                                        {changingValues
                                            ?
                                            <input
                                                value={value1}
                                                onChange={e => { setValue1(e.target.value) }}
                                                name='value1'
                                                type="number"
                                                min="1"
                                                step={"0.1"}
                                                className="form-control text-center placeholder-color-white p-0 text1"
                                                placeholder="€"
                                                style={{ "height": '38px', "background": "#222222", 'fontSize': "20px", "boxShadow": `none`, 'borderRadius': '0.8em', 'border': `3px solid ${offer1_color_primary}`, "color": offer1_color_primary }}
                                            ></input>
                                            : <>{value1}</>
                                        }
                                    </div>
                                    <div className="col-auto p-0 d-flex justify-content-center align-items-center" style={{ 'width': '20%' }}>
                                        <div className="d-flex justify-content-center align-items-center" style={{ 'backgroundColor': '#161616', 'width': '45px', "height": '28px', 'borderRadius': '8px' }}>
                                            {changingValues
                                                ? <BiRefresh onClick={() => setChangingValues(!changingValues)} size={"100%"} style={{ 'maxWidth': '22px' }} />
                                                : <MdOutlineEdit onClick={() => setChangingValues(!changingValues)} size={"100%"} style={{ 'maxWidth': '20px' }} />
                                            }
                                        </div>
                                    </div>
                                    <div className="col fs-2 text-center ps-0 font1" style={{ 'color': offer2_color_primary }}>
                                        {changingValues
                                            ?
                                            <input
                                                value={value2}
                                                onChange={e => { setValue2(e.target.value) }}
                                                name='value2'
                                                type="number"
                                                min="1"
                                                step={"0.1"}
                                                className="form-control text-center placeholder-color-white p-0 text1"
                                                placeholder="€"
                                                style={{ "height": '38px', "background": "#222222", 'fontSize': "20px", "boxShadow": `none`, 'borderRadius': '0.8em', 'border': `3px solid ${offer2_color_primary}`, "color": offer2_color_primary }}
                                            ></input>
                                            : <>{value2}</>
                                        }
                                    </div>
                                </div>
                                {/* account */}
                                <div className={`row pt-3 pb-1 ${!showAccounts && 'd-none'}`}>
                                    <div className="col text-center pe-0 font1">
                                        <input
                                            value={account1}
                                            onChange={e => { setAccount1(e.target.value) }}
                                            name='account1'
                                            type="text"
                                            className="form-control text-center placeholder-color-white p-0 text1 text-secondary text-truncate"
                                            placeholder="Zadaj meno účtu"
                                            list='datalist_account1'
                                            style={{ 'background': 'transparent', 'border': 'none', 'boxShadow': 'none' }}
                                        />
                                        <datalist id='datalist_account1'>
                                            {accounts.filter(e => e.site === offer1_site).map(e => {
                                                return (
                                                    <option id={e.name} value={`${e.account}`} label={`${e.balance.toFixed(2)}€`} />
                                                )
                                            })}
                                        </datalist>
                                    </div>
                                    <div className="col-auto p-0 text-truncate text-uppercase text-secondary d-flex justify-content-center align-items-center font1" style={{ 'width': '20%', 'fontSize': '16px' }}>účet</div>
                                    <div className="col text-center ps-0 font1">
                                        <input
                                            value={account2}
                                            onChange={e => { setAccount2(e.target.value) }}
                                            name='account2'
                                            type="text"
                                            className="form-control text-center placeholder-color-white p-0 text1 text-secondary text-truncate"
                                            placeholder="Zadaj meno účtu"
                                            list='datalist_account2'
                                            style={{ 'background': 'transparent', 'border': 'none', 'boxShadow': 'none' }}
                                        />
                                        <datalist id='datalist_account2'>
                                            {accounts.filter(e => e.site === offer2_site).map(e => {
                                                return (
                                                    <option id={e.name} value={`${e.account}`} label={`${e.balance.toFixed(2)}€`} />
                                                )
                                            })}
                                        </datalist>
                                    </div>
                                </div>
                                {/* available */}
                                <div className={`row ${!showAccounts && 'd-none'}`}>
                                    <div className={`col text-center pe-0 text-secondary font1 ${!showAccounts && 'd-none'}`}>
                                        {roundDigits(accounts.find(e => e.site === offer1_site && e.account === account1)?.balance || 0)}€
                                    </div>
                                    <div className="col-auto p-0 text-truncate text-uppercase text-secondary d-flex justify-content-center align-items-center font1" style={{ 'width': '20%', 'fontSize': '16px' }}>dostupné</div>
                                    <div className="col text-center ps-0 text-secondary font1">
                                        {roundDigits(accounts.find(e => e.site === offer2_site && e.account === account2)?.balance || 0)}€
                                    </div>
                                </div>
                                {/* stake */}
                                <div className="row my-4">
                                    <div className="col text-center pe-0">
                                        <input
                                            value={stake1}
                                            onChange={e => { setStake1(e.target.value); setLastStake(e.target.name) }}
                                            name='stake1'
                                            type="number"
                                            min="0"
                                            step={"10"}
                                            className="form-control text-center text-white placeholder-color-white p-0 text1"
                                            placeholder="€"
                                            style={{ "height": '40px', "background": "#222222", 'fontSize': "20px", "boxShadow": `none`, 'borderRadius': '0.8em', 'border': `3px solid ${offer1_color_primary}` }}
                                        ></input>
                                    </div>
                                    <div className="col-auto p-0 d-flex justify-content-center align-items-center" style={{ 'width': '20%' }}>
                                        <div className="d-flex justify-content-center align-items-center" style={{ 'backgroundColor': '#161616', 'width': '45px', "height": '28px', 'borderRadius': '8px' }}>
                                            {linked
                                                ? <MdLink onClick={() => setLinked(!linked)} size={"100%"} style={{ 'maxWidth': '26px' }} />
                                                : <MdLinkOff onClick={() => setLinked(!linked)} size={"100%"} style={{ 'maxWidth': '26px' }} />
                                            }
                                        </div>
                                    </div>
                                    <div className="col text-center ps-0">
                                        <input
                                            value={stake2}
                                            onChange={e => { setStake2(e.target.value); setLastStake(e.target.name) }}
                                            name='stake2'
                                            type="number"
                                            min="0"
                                            step={"10"}
                                            className="form-control text-center text-white placeholder-color-white p-0 text1"
                                            placeholder="€"
                                            style={{ "height": '40px', "background": "#222222", 'fontSize': "20px", "boxShadow": `none`, 'borderRadius': '0.8em', 'border': `3px solid ${offer2_color_primary}` }}
                                        ></input>                                    </div>
                                </div>
                                {/* payout */}
                                <div className="row">
                                    <div className="col text-center pe-0 text-secondary font1">
                                        {roundDigits(value1 * stake1 || 0)}€                                    </div>
                                    <div className="col-auto p-0 text-truncate text-uppercase text-secondary d-flex justify-content-center align-items-center font1" style={{ 'width': '20%', 'fontSize': '16px' }}>ev. výhra</div>
                                    <div className="col text-center ps-0 text-secondary font1">
                                        {roundDigits(value2 * stake2 || 0)}€
                                    </div>
                                </div>
                                {/* profit */}
                                <div className="row">
                                    <div className="col text-center pe-0 font1 fs-3" style={{ 'color': offer1_color_primary }}>
                                        {roundDigits(value1 * stake1 - stake1 - stake2 || 0)}€
                                    </div>
                                    <div className="col-auto p-0 text-truncate text-uppercase text-secondary d-flex justify-content-center align-items-center font1" style={{ 'width': '20%', 'fontSize': '16px' }}>zisk</div>
                                    <div className="col text-center ps-0 font1 fs-3" style={{ 'color': offer2_color_primary }}>
                                        {roundDigits(value2 * stake2 - stake1 - stake2 || 0)}€
                                    </div>
                                </div>
                                {/* more */}
                                <div className={`row mt-4 ${showMore && 'd-none'}`}>
                                    <div
                                        className="btn-dark col-12 rounded-3 btn mt-2 text-secondary d-flex justify-content-center align-items-center"
                                        style={{ 'height': '40px', 'backgroundColor': '#161616' }}
                                        onClick={() => setShowMore(!showMore)}
                                    >
                                        <BiDotsHorizontalRounded size={"30px"} />
                                    </div>
                                </div>
                                {/* button */}
                                <div className={`row mt-4 ${!showMore && 'd-none'}`}>
                                    <Button onClick={() => setSelected('')} text={'Close'} icon={<MdClose size={'20px'} />} />
                                    <Button
                                        onClick={() => {
                                            (addedToBetTracker ? navigate('/bet-tracker') : createBets({
                                                setAddedToBetTracker, setError, bets: [
                                                    {
                                                        "account": account1,
                                                        "bettype": "arbitrage",
                                                        "game_type": arbitrage.offer1_game_type,
                                                        "site": arbitrage.offer1_site,
                                                        "name": arbitrage.offer1_name,
                                                        "competition": arbitrage.offer1_competition,
                                                        "market": arbitrage.market,
                                                        "bet": arbitrage.offer1_bet,
                                                        "value": value1,
                                                        "stake": stake1,
                                                        "start": arbitrage.offer1_start,
                                                        "sport": arbitrage.offer1_sport,
                                                        "group_key": arbitrage.group_key,
                                                        "status": "pending",
                                                        "sold_price": 0,
                                                    },
                                                    {
                                                        "account": account2,
                                                        "bettype": "arbitrage",
                                                        "game_type": arbitrage.offer2_game_type,
                                                        "site": arbitrage.offer2_site,
                                                        "name": arbitrage.offer2_name,
                                                        "competition": arbitrage.offer2_competition,
                                                        "market": arbitrage.market,
                                                        "bet": arbitrage.offer2_bet,
                                                        "value": value2,
                                                        "stake": stake2,
                                                        "start": arbitrage.offer2_start,
                                                        "sport": arbitrage.offer2_sport,
                                                        "group_key": arbitrage.group_key,
                                                        "status": "pending",
                                                        "sold_price": 0,
                                                    }
                                                ]
                                            }))
                                        }}
                                        text={`${addedToBetTracker ? 'Otvoriť BetTracker' : 'Pridať do BetTracker'}`}
                                        icon={<BiLineChart size={'20px'} />}
                                    />
                                    <Button onClick={() => setShowOdds(!showOdds)} text={`Zobraziť kurzy u iných bookmakerov ${arbitrage.offer1_data.filter(e => e.site != arbitrage.offer1_site).length}/${arbitrage.offer2_data.filter(e => e.site != arbitrage.offer2_site).length}`} icon={<BiHide size={'20px'} />} />
                                    <div className={`container-fluid ${!showOdds && 'd-none'}`} style={{ 'minHeight': '40px' }}>
                                        <div className='row py-2 px-1'>
                                            <div className='col p-0'>
                                                {arbitrage.offer1_data.filter(e => e.site != arbitrage.offer1_site).map(e => {
                                                    return (
                                                        <div style={{ 'color': colors[e.site] }} className='d-flex justify-content-start'>
                                                            <div style={{ 'width': '70px' }}>
                                                                <img src={require(`../../static/images/sites/${e.site}.png`)} style={{ 'borderRadius': '2px' }} className="w-100" alt="Offer 1"></img>
                                                            </div>
                                                            <div className='ps-2'>
                                                                {(e.value ?? e.opening ?? 0).toFixed(2)}
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                            <div className='col p-0'>
                                                {arbitrage.offer2_data.filter(e => e.site != arbitrage.offer2_site).map(e => {
                                                    return (
                                                        <div style={{ 'color': colors[e.site] }} className='d-flex justify-content-end'>
                                                            <div className='pe-2'>
                                                                {(e.value ?? e.opening ?? 0).toFixed(2)}
                                                            </div>
                                                            <div style={{ 'width': '70px' }}>
                                                                <img src={require(`../../static/images/sites/${e.site}.png`)} style={{ 'borderRadius': '2px' }} className="w-100" alt="Offer 1"></img>
                                                            </div>

                                                        </div>)
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                    <Button onClick={() => setShowHide(!showHide)} text={'Skryť pre mňa'} icon={<BiHide size={'20px'} />} />
                                    <div className={`p-0 ps-5 ${!showHide && 'd-none'}`}>
                                        <Button onClick={() => { setShowHide(!showHide); hideGroup(group_key); setSelected('') }} text={'Iba túto arbitráž'} />
                                        <Button onClick={() => { setShowHide(!showHide); hideGame([offer1_gameid, offer2_gameid]); setSelected('') }} text={`Obe hry [${offer2_site},${offer1_site}]`} />
                                        <Button onClick={() => { setShowHide(!showHide); hideGame([offer1_gameid]); setSelected('') }} text={`Táto hra [${offer1_site}]`} />
                                        <Button onClick={() => { setShowHide(!showHide); hideGame([offer2_gameid]); setSelected('') }} text={`Táto hra [${offer2_site}]`} />
                                    </div>
                                    <Button onClick={() => !sure ? setSure(true) : (invalidGame([offer1_gameid, offer2_gameid]), setSure(false), setSelected(''))} text={!sure ? 'Toto nie je arbitráž' : "Som si istý"} icon={<RiEmotionSadLine size={'20px'} />} />
                                    <Button onClick={() => setShowAccounts(!showAccounts)} text={`${showAccounts ? "Neukazovať" : "Zobraziť"} účet/dostupné`} icon={<LuWallet size={'20px'} />} />
                                    <Button onClick={() => setShowInfo(!showInfo)} text={`${showInfo ? "Nezobrazovať" : "Zobraziť"} informácie`} icon={<MdInfoOutline size={'20px'} />} />

                                    <div className={`text-secondary ${!showInfo && 'd-none'}`}>
                                        <div>
                                            created: {createdAgo < 100
                                                ? <>{createdAgo} seconds ago</>
                                                : <>{createdAgo < 6000
                                                    ? <>{(createdAgo / 60).toFixed(0)} minutes ago</>
                                                    : <>{(createdAgo / (60 * 60)).toFixed(0)} hours ago</>
                                                }</>
                                            }
                                        </div>
                                        <div>
                                            updated: {updatedAgo < 100
                                                ? <>{updatedAgo} seconds ago</>
                                                : <>{updatedAgo < 6000
                                                    ? <>{(updatedAgo / 60).toFixed(0)} minutes ago</>
                                                    : <>{(updatedAgo / (60 * 60)).toFixed(0)} hours ago</>
                                                }</>
                                            }
                                        </div>
                                        <div>
                                            checked: {arbitrage.checked} times
                                        </div>
                                        <div>
                                            other odds1: <>{offer1_data.filter(e => e.site != offer1_site).map(e => {
                                                return (
                                                    <span className='px-1' style={{ 'fontSize': '12px', 'color': colors[e.site] }}>{e.value || e.opening}</span>
                                                )
                                            })}</>
                                        </div>
                                        <div>
                                            other odds2: <>{offer2_data.filter(e => e.site != offer2_site).map(e => {
                                                return (
                                                    <span className='px-1' style={{ 'fontSize': '12px', 'color': colors[e.site] }}>{e.value || e.opening}</span>
                                                )
                                            })}</>
                                        </div>
                                        <div>
                                            home similarity: {(arbitrage.similarity_home * 100).toFixed(2)}%
                                        </div>
                                        <div>
                                            away similarity:  {(arbitrage.similarity_away * 100).toFixed(2)}%
                                        </div>
                                        <div>
                                            sport:  {arbitrage.offer1_sport}
                                        </div>
                                        <div>
                                            competition:  {arbitrage.offer1_competition}
                                        </div>
                                        <div>
                                            home paths:  | {[arbitrage.offer1_path1, arbitrage.offer1_path2, arbitrage.offer1_path3].filter(e => e).join(" | ")} |
                                        </div>
                                        <div>
                                            away paths: | {[arbitrage.offer2_path1, arbitrage.offer2_path2, arbitrage.offer2_path3].filter(e => e).join(" | ")} |
                                        </div>
                                        <div>
                                            home verified:  {arbitrage.offer1_sportradarid_verified.toString()}
                                        </div>
                                        <div>
                                            away verified:  {arbitrage.offer2_sportradarid_verified.toString()}
                                        </div>
                                        <div>
                                            home start:  {arbitrage.offer1_start.toString()}
                                        </div>
                                        <div>
                                            away start:  {arbitrage.offer2_start.toString()}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })}
            <Disclamer />
        </>
    )

}

const BigScreen = ({ parameters }) => {
    const { arbitrages, free, unpaidInvoices, userMessage, selected, setSelected, values, membership_type, trial_end, invoices } = parameters
    const { showOptions, setShowOptions, sure, setSure, setError, addedToBetTracker, setAddedToBetTracker, options, setOptions, showAccounts, setShowAccounts, accounts, setAccounts, account1, setAccount1, account2, setAccount2, changingValues, setChangingValues, lastStake, setLastStake, linked, setLinked, value2, setValue2, value1, setValue1, stake2, setStake2, stake1, setStake1 } = values
    const [showMore, setShowMore] = useState(false)
    const [showHide, setShowHide] = useState(false)
    const [showInfo, setShowInfo] = useState(false)
    const [showOdds, setShowOdds] = useState(false)
    const navigate = useNavigate()

    useEffect(() => { setShowMore(false); setShowInfo(false) }, [selected])

    const selected_arbitrage = arbitrages.find(e => e.group_key === selected)

    const createdAgo = (Math.abs(new Date().getTime() - new Date(selected_arbitrage?.createdAt).getTime()) / 1000).toFixed(0)
    const updatedAgo = (Math.abs(new Date().getTime() - new Date(selected_arbitrage?.updatedAt).getTime()) / 1000).toFixed(0)

    const dayNumber = invoices.length ? Math.floor((new Date().setHours(0, 0, 0, 0) - new Date(invoices.slice().sort((a, b) => new Date(b.invoice_date) - new Date(a.invoice_date))[0].invoice_date).setHours(0, 0, 0, 0)) / 86400000) + 1 : null;
    const daysLeft = Math.max(0, Math.floor((new Date(trial_end).setHours(0, 0, 0, 0) - new Date().setHours(0, 0, 0, 0)) / 86400000));

    return (
        <>
            <div className='row '>
                <div
                    className='col-8  text-white overflow-auto'
                    style={{ "height": "calc(100vh - 56px)", "background": '#161616' }}
                >
                    {/* <Bonuses /> */}
                    {/* <FreeVersion free={free} /> */}
                    <UnpaidInvoices unpaidInvoices={unpaidInvoices} />
                    <UserMessage userMessage={userMessage} />
                    {/* <Instagram /> */}
                    {/* <NewBookies /> */}
                    <div className='row mx-sm-2 px-3 px-sm-0'>
                        <div
                            onClick={() => setShowOptions(!showOptions)}
                            className='px-3 col-auto rounded rounded-2 d-flex align-items-center justify-content-center p-0 text-secondary font1'
                            style={{ 'backgroundColor': '#222222', 'cursor': 'pointer' }}
                        >Filter</div>
                        <div
                            onClick={() => navigate('/profile')}
                            className='ms-2 px-3 col-auto rounded rounded-2 d-flex align-items-center justify-content-center p-0 text-secondary font1'
                            style={{
                                'backgroundColor': '#222222', 'cursor': 'pointer',
                            }}>Upozorniť
                        </div>
                        <a
                            href="https://instagram.com/arbitrage.sk"
                            target="_blank"

                            className='col-auto rounded rounded-2 d-flex align-items-center justify-content-center p-0 mx-2'
                            style={{
                                'width': '30px', 'height': '30px',
                                'backgroundColor': '#222222', 'cursor': 'pointer',
                                // 'backgroundImage': "url('https://preview.colorkit.co/gradient/f9ce34-ee2a7b-6228d7.png?size=wallpaper&scale=0.25&static=true')",
                                // 'backgroundSize': '100% 100%',
                                'textDecoration': 'none'
                            }}
                        >
                            <FaInstagram size={'20px'} color='#6C757D' />
                        </a>
                        <div
                            onClick={() => navigate('/pricing')}
                            className={`${(!free) ? 'd-none' : ''} px-3 ${window.innerWidth <= 323 ? 'col-12' : 'col-auto'} me-2 rounded rounded-2 d-flex align-items-center justify-content-center p-0 text-white font-weight-bold font1 ${Math.floor((new Date(trial_end).setHours(0, 0, 0, 0) - new Date().setHours(0, 0, 0, 0)) / 86400000) > -1 && membership_type == 'free' ? 'd-none' : ''}`}
                            style={{
                                'backgroundColor': '#222222', 'cursor': 'pointer', 'height': '30px',
                                'backgroundImage': "url('https://i0.wp.com/css-tricks.com/wp-content/uploads/2020/11/css-gradient.png')",
                                'backgroundSize': '100% 100%',
                            }}>Kúpiť Plnú Verzia
                        </div>
                        <div
                            className={`${membership_type !== 'ultimate' ? 'd-none' : ''} px-3 ${window.innerWidth <= 323 ? 'col-12' : 'col-auto'} rounded rounded-2 d-flex align-items-center justify-content-center p-0 text-white font-weight-bold font1`}
                            style={{
                                'backgroundColor': '#222222', 'cursor': 'pointer', 'height': '30px',
                                'backgroundImage': "url('https://img.freepik.com/free-photo/artistic-blurry-colorful-wallpaper-background_58702-8664.jpg?semt=ais_hybrid&w=740&q=80')",
                                'backgroundSize': '100% 100%',
                            }}>Ultimate{dayNumber ? ` - ${dayNumber}. deň` : ''}
                        </div>
                        <div
                            className={`${membership_type !== 'premium' ? 'd-none' : ''} px-3 ${window.innerWidth <= 323 ? 'col-12' : 'col-auto'} rounded rounded-2 d-flex align-items-center justify-content-center p-0 text-white font-weight-bold font1`}
                            style={{
                                'backgroundColor': '#222222', 'cursor': 'pointer', 'height': '30px',
                                'backgroundImage': "url('https://img.freepik.com/premium-photo/abstract-red-background-web-design-templates-product-studio-with-smooth-gradient-color_570543-7721.jpg?semt=ais_hybrid&w=740&q=80')",
                                'backgroundSize': '100% 100%',
                            }}>Premium{dayNumber ? ` - ${dayNumber}. deň` : ''}
                        </div>
                        <div
                            className={`${Math.floor((new Date(trial_end).setHours(0, 0, 0, 0) - new Date().setHours(0, 0, 0, 0)) / 86400000) > -1 && membership_type == 'free' ? '' : 'd-none'} px-3 ${window.innerWidth <= 323 ? 'col-12' : 'col-auto'} rounded rounded-2 d-flex align-items-center justify-content-center p-0 text-white font-weight-bold font1`}
                            style={{
                                'backgroundColor': '#222222', 'cursor': 'pointer', 'height': '30px',
                                'backgroundImage': "url('https://img.freepik.com/premium-photo/cool-luxury-bottle-green-gradient-background_703141-6.jpg?semt=ais_hybrid&w=740&q=80')",
                                'backgroundSize': '100% 100%',
                            }}>Skúška Ultimate{daysLeft || daysLeft === 0 ? ` - ostáva ${daysLeft} dní` : ''}
                        </div>

                    </div>
                    <Options options={options} setOptions={setOptions} setShowOptions={setShowOptions} showOptions={showOptions} />

                    <OnboardingBanner invoices={invoices} />

                    <NothingFound arbitrages={arbitrages} />
                    <div style={{ "height": '15px' }}></div>
                    {arbitrages.map(arbitrage => {
                        const { offer1_gameid, offer2_gameid, offer1_start, id, group_key, roi, offer1_url, offer2_url, offer1_site, offer2_site, offer1_home, offer2_away, market, market_quantity, offer1_bet, offer2_bet, offer1_color_primary, offer2_color_primary } = arbitrage
                        const start = formatIsoString(offer1_start)

                        const createdAgo = (Math.abs(new Date().getTime() - new Date(arbitrage.createdAt).getTime()) / 1000).toFixed(0)
                        const updatedAgo = (Math.abs(new Date().getTime() - new Date(arbitrage.updatedAt).getTime()) / 1000).toFixed(0)




                        return (
                            <div
                                style={{ 'border': `${group_key === selected ? '' : 'solid 3px rgba(255, 0, 0, 0) '}`, "background": "#222222", 'minHeight': '100px' }}
                                className={`font2 row mx-1 mb-3  rounded rounded-4 align-middle ${group_key == selected ? 'border border-3 border-white' : ''}`}
                                onClick={() => (group_key != selected && setSelected(group_key))}
                                key={arbitrage.id}
                            >
                                <div className=' d-flex justify-content-center align-items-center' style={{ 'width': window.innerWidth <= 1250 ? '80px' : '150px', 'fontSize': window.innerWidth <= 1250 ? '1.2rem' : '1.65rem' }}>
                                    {arbitrage.roi.toFixed(2)}%
                                </div>
                                <div className='col p-0'>
                                    <div className='h-100 d-flex flex-column justify-content-center'>
                                        <div className='container-fluid'>
                                            <div className='row'>
                                                <div className='col-auto d-flex align-items-end justify-content-center p-0 w-100' style={{ 'maxWidth': '70px', 'fontSize': window.innerWidth <= 1250 ? '0.8rem' : '1rem' }}>
                                                    <span>{start.dateText}</span>
                                                </div>
                                                <div className='col d-flex align-items-end' style={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                    <span className='lh-base d-inline-block text-truncate' style={{ width: '100%', 'fontSize': window.innerWidth <= 1050 ? '0.8rem' : '1rem' }}>
                                                        {arbitrage.offer1_home}
                                                        <span className="text-secondary" style={{ fontSize: '12px' }}> vs. </span>
                                                        {arbitrage.offer2_away}{(arbitrage.offer1_is_top || arbitrage.offer2_is_top) &&
                                                            <span className=''>
                                                                <GoDotFill color='#FFD700' />
                                                            </span>
                                                        } - {updatedAgo}s
                                                    </span>
                                                </div>
                                                <div className='col-auto p-0 d-flex align-items-end text-secondary text-uppercase' style={{ 'fontSize': window.innerWidth <= 1250 ? '0.8rem' : '1rem' }}>
                                                    {arbitrage.offer1_bet}
                                                </div>
                                                <div className='col-auto py-0 px-1 mx-2 d-flex align-items-end' style={{ width: window.innerWidth <= 1250 ? '70px' : '80px' }}>
                                                    {['nike', 'tipsport', 'doxxbet', 'fortuna', 'synottip', 'tipos', 'bet365', 'pinnacle'].includes(offer1_site)
                                                        ?
                                                        <Link to={offer1_url} target="_blank" className="w-100 h-100 d-flex justify-content-center align-items-start">
                                                            <img
                                                                src={require(`../../static/images/sites/${offer1_site}.png`)}
                                                                style={{ maxWidth: '100%', height: 'auto', marginTop: '2px' }}
                                                                className="rounded-1"
                                                                alt="Offer 1"
                                                            />
                                                        </Link>
                                                        : <div>{offer1_site}</div>
                                                    }
                                                </div>
                                                <div className='col-auto p-0 d-flex align-items-end' style={{ 'width': '50px', 'color': arbitrage.offer1_color_primary, 'fontSize': window.innerWidth <= 1250 ? '0.8rem' : '1rem' }}>
                                                    <span>{arbitrage.offer1_value}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='container-fluid'>
                                            <div className='row'>
                                                <div className='col-auto d-flex align-items-start justify-content-center p-0 w-100' style={{ 'maxWidth': '70px', 'fontSize': window.innerWidth <= 1250 ? '0.8rem' : '1rem' }}>
                                                    <span>{start.hour}:{start.minute}</span>
                                                </div>

                                                <div className='col d-flex align-items-start' style={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                    <span className='lh-base d-inline-block text-truncate text-secondary text-uppercase' style={{ width: '100%', 'fontSize': window.innerWidth <= 1050 ? '0.8rem' : '1rem' }}>
                                                        {arbitrage.market}</span>
                                                </div>
                                                <div className='col-auto p-0 d-flex align-items-start text-secondary text-uppercase' style={{ 'fontSize': window.innerWidth <= 1250 ? '0.8rem' : '1rem' }}>
                                                    {arbitrage.offer2_bet}
                                                </div>
                                                <div className='col-auto py-0 px-1 mx-2 d-flex align-items-start' style={{ width: window.innerWidth <= 1250 ? '70px' : '80px' }}>
                                                    {['nike', 'tipsport', 'doxxbet', 'fortuna', 'synottip', 'tipos', 'bet365', 'pinnacle'].includes(arbitrage.offer2_site)
                                                        ?
                                                        <Link to={offer2_url} target="_blank" className="w-100 h-100 d-flex justify-content-center align-items-start">
                                                            <img
                                                                src={require(`../../static/images/sites/${offer2_site}.png`)}
                                                                style={{ maxWidth: '100%', height: 'auto', marginTop: '2px' }}
                                                                className="rounded-1"
                                                                alt="Offer 1"
                                                            />
                                                        </Link>
                                                        : <div>{arbitrage.offer2_site}</div>
                                                    }
                                                </div>
                                                <div className='col-auto p-0 d-flex align-items-start' style={{ 'width': '50px', 'color': arbitrage.offer2_color_primary, 'fontSize': window.innerWidth <= 1250 ? '0.8rem' : '1rem' }}>
                                                    <span>{arbitrage.offer2_value}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='d-flex justify-content-center align-items-center' style={{ 'width': window.innerWidth <= 1450 ? '50px' : '100px' }}>
                                    <div>
                                        {['football', 'tennis', 'hockey', 'basketball', 'handball', 'volleyball'].includes(arbitrage.offer1_sport)
                                            ? <img src={require(`../../static/images/sports/${arbitrage.offer1_sport}.png`)} className='w-100' style={{ 'maxWidth': '36px' }}></img>
                                            : <div>{ }</div>
                                        }
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                    <Disclamer />
                </div>
                <div className='col-4 p-0 pe-3'>
                    {selected_arbitrage &&
                        <div
                            className="rounded rounded-4 container-fluid py-2 overflow-auto pb-2"
                            style={{ 'height': "calc(100vh - 72px)", "background": "#222222", 'padding': window.innerWidth <= 1450 ? '1rem' : '2rem' }}
                        >
                            <div className='row mx-0 mb-5'><div className='text-light text-center fs-3'>Detaily</div></div>

                            {/* site */}
                            <div className='row mx-0 mt-4'>
                                <div className='col d-flex justify-content-center'>
                                    {['nike', 'tipsport', 'doxxbet', 'fortuna', 'synottip', 'tipos', 'bet365', 'pinnacle'].includes(selected_arbitrage.offer1_site)
                                        ?
                                        <Link to={selected_arbitrage.offer1_url} target="_blank" className="d-flex align-items-center">
                                            <img src={require(`../../static/images/sites/${selected_arbitrage.offer1_site}.png`)} style={{ 'maxWidth': window.innerWidth <= 1150 ? '80px' : '100px' }} className="rounded w-100" alt="Offer 1"></img>
                                        </Link>
                                        : <div>{selected_arbitrage.offer1_site}</div>
                                    }

                                </div>
                                <div className='col-2'></div>
                                <div className='col d-flex justify-content-center'>
                                    {['nike', 'tipsport', 'doxxbet', 'fortuna', 'synottip', 'tipos', 'bet365', 'pinnacle'].includes(selected_arbitrage.offer2_site)
                                        ?
                                        <Link to={selected_arbitrage.offer2_url} target="_blank" className="d-flex align-items-center">
                                            <img src={require(`../../static/images/sites/${selected_arbitrage.offer2_site}.png`)} style={{ 'maxWidth': window.innerWidth <= 1150 ? '80px' : '100px' }} className="rounded w-100" alt="Offer 1"></img>
                                        </Link>
                                        : <div>{selected_arbitrage.offer2_site}</div>
                                    }
                                </div>
                            </div>
                            {/* name */}
                            <div className='row mx-0 mt-4'>
                                <div className='col-5 d-flex justify-content-center flex-column text-center' style={{ fontSize: window.innerWidth <= 1150 ? '0.85rem' : '1rem' }}>
                                    <div className='lh-1 my-1'>{selected_arbitrage.offer1_home}</div>
                                    <div className='lh-1 my-1'>{selected_arbitrage.offer1_away}</div>
                                    <div className='text-secondary text-uppercase lh-1 my-1'>{selected_arbitrage.offer1_competition}</div>
                                </div>
                                <div className='col-2'></div>
                                <div className='col-5 d-flex justify-content-center flex-column text-center' style={{ fontSize: window.innerWidth <= 1150 ? '0.85rem' : '1rem' }}>
                                    <div className='lh-1 my-1'>{selected_arbitrage.offer2_home}</div>
                                    <div className='lh-1 my-1'>{selected_arbitrage.offer2_away}</div>
                                    <div className='text-secondary text-uppercase lh-1 my-1'>{selected_arbitrage.offer2_competition}</div>
                                </div>
                            </div>
                            {/* paths */}
                            <div className='row mx-0 mt-4'>
                                <div className='col-5 d-flex justify-content-center flex-column text-center' style={{ fontSize: window.innerWidth <= 1150 ? '0.85rem' : '1rem', 'cursor': 'pointer' }}>
                                    <div className='lh-1 my-1' onClick={() => { navigator.clipboard.writeText(selected_arbitrage.offer1_path1) }}>
                                        {selected_arbitrage.offer1_path1}</div>
                                    <div className='lh-1 my-1' onClick={() => { navigator.clipboard.writeText((selected_arbitrage.offer1_path2 ? selected_arbitrage.offer1_path2 : selected_arbitrage.offer1_path3)) }}>
                                        {selected_arbitrage.offer1_path2 ? selected_arbitrage.offer1_path2 : selected_arbitrage.offer1_path3}</div>
                                    <div className='lh-1 my-1' onClick={() => { navigator.clipboard.writeText((selected_arbitrage.offer1_path2 ? selected_arbitrage.offer1_path3 : "")) }}>
                                        {selected_arbitrage.offer1_path2 ? selected_arbitrage.offer1_path3 : ""}</div>
                                </div>
                                <div className='col-2'></div>
                                <div className='col-5 d-flex justify-content-center flex-column text-center ' style={{ fontSize: window.innerWidth <= 1150 ? '0.85rem' : '1rem', 'cursor': 'pointer' }}>
                                    <div className='lh-1 my-1' onClick={() => { navigator.clipboard.writeText(selected_arbitrage.offer2_path1) }}>
                                        {selected_arbitrage.offer2_path1}</div>
                                    <div className='lh-1 my-1' onClick={() => { navigator.clipboard.writeText((selected_arbitrage.offer2_path2 ? selected_arbitrage.offer2_path2 : selected_arbitrage.offer2_path3)) }}>
                                        {selected_arbitrage.offer2_path2 ? selected_arbitrage.offer2_path2 : selected_arbitrage.offer2_path3}</div>
                                    <div className='lh-1 my-1' onClick={() => { navigator.clipboard.writeText((selected_arbitrage.offer2_path2 ? selected_arbitrage.offer2_path3 : "")) }}>
                                        {selected_arbitrage.offer2_path2 ? selected_arbitrage.offer2_path3 : ""}</div>
                                </div>
                            </div>
                            {/* value */}
                            <div className='row mx-0 mt-4'>
                                <div className='col d-flex justify-content-center flex-column text-center'>
                                    {changingValues
                                        ?
                                        <input
                                            value={value1}
                                            onChange={e => { setValue1(e.target.value) }}
                                            name='value1'
                                            type="number"
                                            min="1"
                                            step={"0.1"}
                                            className="form-control text-center placeholder-color-white p-0 text1 rounded rounded-3"
                                            placeholder="€"
                                            style={{ "height": '38px', "background": "#222222", 'fontSize': "20px", "boxShadow": `none`, 'border': `3px solid ${selected_arbitrage.offer1_color_primary}`, "color": selected_arbitrage.offer1_color_primary }}
                                        ></input>
                                        : <span className='fs-3' style={{ 'color': selected_arbitrage.offer1_color_primary }}>{value1}</span>
                                    }
                                </div>
                                <div className='col-2 d-flex justify-content-center text-secondary'>
                                    {changingValues
                                        ? <BiRefresh onClick={() => setChangingValues(!changingValues)} size={"100%"} style={{ 'maxWidth': '22px' }} />
                                        : <MdOutlineEdit onClick={() => setChangingValues(!changingValues)} size={"100%"} style={{ 'maxWidth': '20px' }} />
                                    }
                                </div>

                                <div className='col d-flex justify-content-center flex-column text-center'>
                                    {changingValues
                                        ?
                                        <input
                                            value={value2}
                                            onChange={e => { setValue2(e.target.value) }}
                                            name='value2'
                                            type="number"
                                            min="1"
                                            step={"0.1"}
                                            className="form-control text-center placeholder-color-white p-0 text1"
                                            placeholder="€"
                                            style={{ "height": '38px', "background": "#222222", 'fontSize': "20px", "boxShadow": `none`, 'borderRadius': '0.8em', 'border': `3px solid ${selected_arbitrage.offer2_color_primary}`, "color": selected_arbitrage.offer2_color_primary }}
                                        ></input>
                                        : <span className='fs-3' style={{ 'color': selected_arbitrage.offer2_color_primary }}>{value2}</span>
                                    }
                                </div>
                            </div>
                            {/* stake */}
                            <div className='row mx-0 my-4'>
                                <div className='col'>
                                    <input
                                        value={stake1}
                                        onChange={e => { setStake1(e.target.value); setLastStake(e.target.name) }}
                                        name='stake1'
                                        type="number"
                                        min="0"
                                        step={"10"}
                                        className="form-control text-center placeholder-color-white p-0 text1 rounded rounded-3"
                                        placeholder="€"
                                        style={{ "height": '40px', "background": "#222222", 'fontSize': "20px", "boxShadow": `none`, 'border': `3px solid ${selected_arbitrage.offer1_color_primary}`, 'color': `${selected_arbitrage.offer1_color_primary}` }}
                                    ></input>
                                </div>
                                <div className='col-2 d-flex justify-content-center text-secondary'>
                                    {linked
                                        ? <MdLink onClick={() => setLinked(!linked)} size={"100%"} style={{ 'maxWidth': '26px' }} />
                                        : <MdLinkOff onClick={() => setLinked(!linked)} size={"100%"} style={{ 'maxWidth': '26px' }} />
                                    }
                                </div>
                                <div className='col'>
                                    <input
                                        value={stake2}
                                        onChange={e => { setStake2(e.target.value); setLastStake(e.target.name) }}
                                        name='stake2'
                                        type="number"
                                        min="0"
                                        step={"10"}
                                        className="form-control text-center placeholder-color-white p-0 text1 rounded rounded-3"
                                        placeholder="€"
                                        style={{ "height": '40px', "background": "#222222", 'fontSize': "20px", "boxShadow": `none`, 'border': `3px solid ${selected_arbitrage.offer2_color_primary}`, 'color': `${selected_arbitrage.offer2_color_primary}` }}
                                    ></input>
                                </div>
                            </div>
                            {/* account */}
                            <div className={`row mx-0 mt-1 ${!showAccounts && 'd-none'}`}>
                                <div className='col'>
                                    <input
                                        value={account1}
                                        onChange={e => { setAccount1(e.target.value) }}
                                        name='account1'
                                        type="text"
                                        className="form-control text-center placeholder-color-white p-0 text1 text-light text-truncate rounded rounded-3 "
                                        placeholder="Zadaj meno účtu"
                                        list='datalist_account1'
                                        style={{ 'fontSize': window.innerWidth <= 1450 ? '1rem' : '1rem', 'background': '#222222', 'boxShadow': 'none', 'border': `none` }}
                                    />
                                    <datalist id='datalist_account1'>
                                        {accounts.filter(e => e.site === selected_arbitrage.offer1_site).map(e => {
                                            return (
                                                <option onClick={() => setAccount1(e.account)} id={e.account} value={`${e.account}`} label={`${e.balance.toFixed(2)}€`} />
                                            )
                                        })}
                                    </datalist>
                                </div>
                                <div className='col-2 d-flex justify-content-center font1 text-secondary text-uppercase align-items-center'>
                                    účet
                                </div>
                                <div className='col '>
                                    <input
                                        value={account2}
                                        onChange={e => { setAccount2(e.target.value) }}
                                        name='account2'
                                        type="text"
                                        className="form-control text-center placeholder-color-white p-0 text1 text-light text-truncate rounded rounded-3 "
                                        placeholder="Zadaj meno účtu"
                                        list='datalist_account2'
                                        style={{ 'fontSize': window.innerWidth <= 1450 ? '1rem' : '1rem', 'background': '#222222', 'boxShadow': 'none', 'border': `none` }}
                                    />
                                    <datalist id='datalist_account2'>
                                        {accounts.filter(e => e.site === selected_arbitrage.offer2_site).map(e => {
                                            return (
                                                <option onClick={() => setAccount2(e.account)} id={e.account} value={`${e.account}`} label={`${e.balance.toFixed(2)}€`} />
                                            )
                                        })}
                                    </datalist>
                                </div>
                            </div>
                            {/* available */}
                            <div className={`row mx-0 mt-1 ${!showAccounts && 'd-none'}`}>
                                <div className='col d-flex justify-content-center'>
                                    {roundDigits(accounts.find(e => e.site === selected_arbitrage.offer1_site && e.account === account1)?.balance || 0)}
                                </div>
                                <div className='col-2 d-flex justify-content-center font1 text-secondary text-uppercase'>
                                    dostupné
                                </div>
                                <div className='col d-flex justify-content-center'>
                                    {roundDigits(accounts.find(e => e.site === selected_arbitrage.offer2_site && e.account === account2)?.balance || 0)}
                                </div>
                            </div>
                            {/* payout */}
                            <div className='row mx-0 mt-1'>
                                <div className='col d-flex justify-content-center'>
                                    {roundDigits(value1 * stake1 || 0)}
                                </div>
                                <div className='col-2 d-flex justify-content-center font1 text-secondary text-uppercase'>
                                    výhra
                                </div>
                                <div className='col d-flex justify-content-center'>
                                    {roundDigits(value2 * stake2 || 0)}
                                </div>
                            </div>
                            {/* profit */}
                            <div className='row mx-0 mt-1'>
                                <div className='col d-flex justify-content-center fs-5' style={{ color: selected_arbitrage.offer1_color_primary }}>
                                    {roundDigits(value1 * stake1 - stake1 - stake2 || 0)}
                                </div>
                                <div className='col-2 d-flex justify-content-center align-items-center font1 text-secondary text-uppercase'>
                                    zisk
                                </div>
                                <div className='col d-flex justify-content-center fs-5' style={{ color: selected_arbitrage.offer2_color_primary }}>
                                    {roundDigits(value2 * stake2 - stake1 - stake2 || 0)}
                                </div>
                            </div>
                            {/* buttons */}
                            <div className='row mx-0'>
                                <Button
                                    onClick={() => {
                                        (addedToBetTracker ? navigate('/bet-tracker') : createBets({
                                            setAddedToBetTracker, setError, bets: [
                                                {
                                                    "account": account1,
                                                    "bettype": "arbitrage",
                                                    "game_type": selected_arbitrage.offer1_game_type,
                                                    "site": selected_arbitrage.offer1_site,
                                                    "name": selected_arbitrage.offer1_name,
                                                    "competition": selected_arbitrage.offer1_competition,
                                                    "market": selected_arbitrage.market,
                                                    "bet": selected_arbitrage.offer1_bet,
                                                    "value": value1,
                                                    "stake": stake1,
                                                    "start": selected_arbitrage.offer1_start,
                                                    "sport": selected_arbitrage.offer1_sport,
                                                    "group_key": selected_arbitrage.group_key,
                                                    "status": "pending",
                                                    "sold_price": 0,
                                                },
                                                {
                                                    "account": account2,
                                                    "bettype": "arbitrage",
                                                    "game_type": selected_arbitrage.offer2_game_type,
                                                    "site": selected_arbitrage.offer2_site,
                                                    "name": selected_arbitrage.offer2_name,
                                                    "competition": selected_arbitrage.offer2_competition,
                                                    "market": selected_arbitrage.market,
                                                    "bet": selected_arbitrage.offer2_bet,
                                                    "value": value2,
                                                    "stake": stake2,
                                                    "start": selected_arbitrage.offer2_start,
                                                    "sport": selected_arbitrage.offer2_sport,
                                                    "group_key": selected_arbitrage.group_key,
                                                    "status": "pending",
                                                    "sold_price": 0,
                                                }
                                            ]
                                        }))
                                    }}
                                    text={`${addedToBetTracker ? 'Otvoriť BetTracker' : 'Pridať do BetTracker'}`}
                                    icon={<BiLineChart size={'20px'} />}
                                />
                                <Button onClick={() => setShowOdds(!showOdds)} text={`Ukázať kurzy na iných stránkach ${selected_arbitrage.offer1_data.filter(e => e.site != selected_arbitrage.offer1_site).length} / ${selected_arbitrage.offer2_data.filter(e => e.site != selected_arbitrage.offer2_site).length}`} icon={<BiHide size={'20px'} />} />
                                <div className={`container-fluid ${!showOdds && 'd-none'}`} style={{ 'minHeight': '40px' }}>
                                    <div className='row py-2 px-1'>
                                        <div className='col p-0'>
                                            {selected_arbitrage.offer1_data.filter(e => e.site != selected_arbitrage.offer1_site).map(e => {
                                                return (
                                                    <div style={{ 'color': colors[e.site] }} className='d-flex justify-content-start'>
                                                        <div style={{ 'width': '70px' }}>
                                                            <img src={require(`../../static/images/sites/${e.site}.png`)} style={{ 'borderRadius': '2px' }} className="w-100" alt="Offer 1"></img>
                                                        </div>
                                                        <div className='ps-2'>
                                                            {(e.value || e.opening).toFixed(2)}
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                        <div className='col p-0'>
                                            {selected_arbitrage.offer2_data.filter(e => e.site != selected_arbitrage.offer2_site).map(e => {
                                                return (
                                                    <div style={{ 'color': colors[e.site] }} className='d-flex justify-content-end'>
                                                        <div className='pe-2'>
                                                            {(e.value || e.opening).toFixed(2)}
                                                        </div>
                                                        <div style={{ 'width': '70px' }}>
                                                            <img src={require(`../../static/images/sites/${e.site}.png`)} style={{ 'borderRadius': '2px' }} className="w-100" alt="Offer 1"></img>
                                                        </div>

                                                    </div>)
                                            })}
                                        </div>
                                    </div>

                                </div>
                                <Button onClick={() => setShowHide(!showHide)} text={'Skryť'} icon={<BiHide size={'20px'} />} />
                                <div className={`p-0 ps-5 ${!showHide && 'd-none'}`}>
                                    <Button onClick={() => { setShowHide(!showHide); hideGroup(selected_arbitrage.group_key); setSelected('') }} text={'Iba tento surebet'} />
                                    <Button onClick={() => { setShowHide(!showHide); hideGame([selected_arbitrage.offer1_gameid, selected_arbitrage.offer2_gameid]); setSelected('') }} text={`Obidve hry [${selected_arbitrage.offer2_site},${selected_arbitrage.offer1_site}]`} />
                                    <Button onClick={() => { setShowHide(!showHide); hideGame([selected_arbitrage.offer1_gameid]); setSelected('') }} text={`Táto hra [${selected_arbitrage.offer1_site}]`} />
                                    <Button onClick={() => { setShowHide(!showHide); hideGame([selected_arbitrage.offer2_gameid]); setSelected('') }} text={`Táto hra [${selected_arbitrage.offer2_site}]`} />
                                </div>
                                <Button onClick={() => !sure ? setSure(true) : (invalidGame([selected_arbitrage.offer1_gameid, selected_arbitrage.offer2_gameid]), setSure(false), setSelected(''))} text={!sure ? 'Toto neni surebet' : "Som si istý"} icon={<RiEmotionSadLine size={'20px'} />} />
                                <Button onClick={() => setShowAccounts(!showAccounts)} text={`${showAccounts ? "Neukazovať" : "Zobraziť"} Účet/dostupné`} icon={<LuWallet size={'20px'} />} />
                                <Button onClick={() => setShowInfo(!showInfo)} text={`${showInfo ? "Nezobrazovať" : "Zobraziť"} Info`} icon={<MdInfoOutline size={'20px'} />} />

                                <div className={`text-secondary ${!showInfo && 'd-none'}`}>
                                    <div>
                                        created: {createdAgo < 100
                                            ? <>{createdAgo} seconds ago</>
                                            : <>{createdAgo < 6000
                                                ? <>{(createdAgo / 60).toFixed(0)} minutes ago</>
                                                : <>{(createdAgo / (60 * 60)).toFixed(0)} hours ago</>
                                            }</>
                                        }
                                    </div>
                                    <div>
                                        updated: {updatedAgo < 100
                                            ? <>{updatedAgo} seconds ago</>
                                            : <>{updatedAgo < 6000
                                                ? <>{(updatedAgo / 60).toFixed(0)} minutes ago</>
                                                : <>{(updatedAgo / (60 * 60)).toFixed(0)} hours ago</>
                                            }</>
                                        }
                                    </div>
                                    <div>
                                        checked: {selected_arbitrage.checked} times
                                    </div>
                                    <div>
                                        other odds1: <>{selected_arbitrage.offer1_data.filter(e => e.site != selected_arbitrage.offer1_site).map(e => {
                                            return (
                                                <span className='px-1' style={{ 'fontSize': '12px', 'color': colors[e.site] }}>{e.value || e.opening}</span>
                                            )
                                        })}</>
                                    </div>
                                    <div>
                                        other odds2: <>{selected_arbitrage.offer2_data.filter(e => e.site != selected_arbitrage.offer2_site).map(e => {
                                            return (
                                                <span className='px-1' style={{ 'fontSize': '12px', 'color': colors[e.site] }}>{e.value || e.opening}</span>
                                            )
                                        })}</>
                                    </div>
                                    <div>
                                        home similarity: {(selected_arbitrage.similarity_home * 100).toFixed(2)}%
                                    </div>
                                    <div>
                                        away similarity:  {(selected_arbitrage.similarity_away * 100).toFixed(2)}%
                                    </div>
                                    <div>
                                        sport:  {selected_arbitrage.offer1_sport}
                                    </div>
                                    <div>
                                        competition:  {selected_arbitrage.offer1_competition}
                                    </div>
                                    <div>
                                        home paths:  | {[selected_arbitrage.offer1_path1, selected_arbitrage.offer1_path2, selected_arbitrage.offer1_path3].filter(e => e).join(" | ")} |
                                    </div>
                                    <div>
                                        away paths: | {[selected_arbitrage.offer2_path1, selected_arbitrage.offer2_path2, selected_arbitrage.offer2_path3].filter(e => e).join(" | ")} |
                                    </div>
                                    <div>
                                        home verified:  {selected_arbitrage.offer1_sportradarid_verified.toString()}
                                    </div>
                                    <div>
                                        away verified:  {selected_arbitrage.offer2_sportradarid_verified.toString()}
                                    </div>
                                    <div>
                                        home start:  {selected_arbitrage.offer1_start.toString()}
                                    </div>
                                    <div>
                                        away start:  {selected_arbitrage.offer2_start.toString()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div >
        </>
    )
}

const PrematchArbitrage = () => {
    const token = getCookie('token')
    const newDataIn = 3000
    const [arbitrages, setArbitrages] = useState([])
    const [free, setFree] = useState(false)
    const [unpaidInvoices, setUnpaidInvoices] = useState([])
    const [userMessage, setUserMessage] = useState('')
    const [dataFetched, setDataFetched] = useState(false)
    const [error, setError] = useState('')
    const [selected, setSelected] = useState('')
    const [accounts, setAccounts] = useState([])
    const [membership_type, setMembership_type] = useState('')
    const [trial_end, setTrial_end] = useState('')
    const [invoices, setInvoices] = useState([])

    const [account1, setAccount1] = useState('')
    const [account2, setAccount2] = useState('')

    const [stake1, setStake1] = useState('')
    const [stake2, setStake2] = useState('')
    const [value1, setValue1] = useState('')
    const [value2, setValue2] = useState('')
    const [linked, setLinked] = useState(true)
    const [lastStake, setLastStake] = useState('')
    const [changingValues, setChangingValues] = useState(false)
    const [showAccounts, setShowAccounts] = useState((getCookie("showAccount") === "false") ? false : true)
    const [options, setOptions] = useState(getCookie('options') ? JSON.parse(getCookie('options')) : defaultOptions)
    const [addedToBetTracker, setAddedToBetTracker] = useState(false)
    const [sure, setSure] = useState(false)
    const navigate = useNavigate()
    const [showOptions, setShowOptions] = useState(false)
    const startedRef = useRef(false)

    const values = { showOptions, setShowOptions, sure, setSure, setError, addedToBetTracker, setAddedToBetTracker, options, setOptions, showAccounts, setShowAccounts, accounts, setAccounts, account1, setAccount1, account2, setAccount2, changingValues, setChangingValues, lastStake, setLastStake, linked, setLinked, value2, setValue2, value1, setValue1, stake2, setStake2, stake1, setStake1 }

    useEffect(() => {
        if (getCookie('filtersResetedTiposSynottip') !== 'true') {
            setOptions(defaultOptions)
            setCookie('filtersResetedTiposSynottip', 'true')
        }
    }, [])

    useEffect(() => {
        if (arbitrages.length > 0) {
            if (!arbitrages.some(e => e.group_key === selected)) {
                if (window.innerWidth > 950) {
                    setSelected(arbitrages[0].group_key)
                }
            }
        }
    }, [arbitrages])

    // const fetchNewData = async () => {
    //     if (!startedRef.current) {
    //         startedRef.current = true;
    //         if (!token) { navigate('/') }
    //         axios.post(`${process.env.REACT_APP_API}/abitrage/prematch`, { token, options: JSON.parse(getCookie('options')) })
    //             .then(response => {
    //                 setArbitrages(response.data.arbitrages)
    //                 setUnpaidInvoices(response.data.invoices.filter(e => e.payment_state === "not_paid").length)
    //                 setDataFetched(true)
    //                 setFree(response.data.free)
    //                 setUserMessage(response.data.user_message)
    //                 setAccounts(response.data.accounts)
    //                 startedRef.current = false

    //             })
    //             .catch(error => {
    //                 startedRef.current = false
    //                 // setError(error?.response?.data?.error || '')
    //                 // setArbitrages([])
    //                 // setUnpaidInvoices([])
    //                 // setDataFetched(true)
    //                 // setFree(null)
    //                 // setUserMessage('')
    //                 // setAccounts([])
    //             })
    //     }
    // }

    const fetchNewData = async () => {
        if (!startedRef.current) {
            startedRef.current = true;
            if (!token) {
                navigate('/');
                return;
            }

            try {
                const response = await axios.post(
                    `${process.env.REACT_APP_API}/abitrage/prematch`,
                    { token, options: JSON.parse(getCookie('options') || '{}') },
                    { headers: { 'Content-Type': 'application/json' } }
                );

                setArbitrages(response.data.arbitrages);
                setUnpaidInvoices(response.data.invoices.filter(e => e.payment_state === "not_paid").length);
                setDataFetched(true);
                setFree(response.data.free);
                setUserMessage(response.data.user_message);
                setAccounts(response.data.accounts);
                setMembership_type(response.data.membership_type);
                setTrial_end(response.data.trial_end);
                setInvoices(response.data.invoices);

            } catch (error) {
                console.log('Chyba API:', error.response?.status, error.response?.data);

                // reset dát, aby UI neostalo zamrznuté
                setArbitrages([]);
                setUnpaidInvoices([]);
                setDataFetched(true);
                setFree(null);
                setUserMessage(error.response?.data?.user_message || '');
                setAccounts([]);
                setMembership_type(null)
                setTrial_end(null);
                setInvoices([]);
            } finally {
                startedRef.current = false;
            }
        }
    };

    useEffect(() => {
        setCookie("options", (JSON.stringify(options)))
        fetchNewData()
    }, [options])

    useEffect(() => {
        const arbitrage = arbitrages.find(e => e.group_key === selected)
        if (arbitrage) {
            setCookie(`lastAccount_${arbitrage.offer1_site}`, account1)
            setCookie(`lastAccount_${arbitrage.offer2_site}`, account2)
        }
    }, [account1, account2])

    useEffect(() => {
        setError('')
        fetchNewData()
        const interval = setInterval(fetchNewData, newDataIn)
        return () => clearInterval(interval)
    }, [token])

    useEffect(() => {
        if (error) {
            console.log('errorerror', error)
            toast.error(error)
        }
    }, [error])

    useEffect(() => {
        const arbitrage = arbitrages.find(e => e.group_key === selected)
        if (arbitrage) {
            fetchNewData()
            setAccount1(getCookie(`lastAccount_${arbitrage.offer1_site}`) || "")
            setAccount2(getCookie(`lastAccount_${arbitrage.offer2_site}`) || "")
            setSure(false)
            setAddedToBetTracker(false)
        }
    }, [selected])

    useEffect(() => {
        if (!changingValues && selected) {
            const selectedArbitrage = arbitrages.find(e => e.group_key === selected)
            if (selectedArbitrage) {
                setValue1(selectedArbitrage.offer1_value)
                setValue2(selectedArbitrage.offer2_value)
            }
        }
    }, [changingValues, selected, arbitrages])

    useEffect(() => {
        setStake1('')
        setStake2('')
        setLastStake('')
    }, [value1, value2])

    useEffect(() => {
        const arbitrage = arbitrages.find(e => e.group_key === selected)
        if (linked && arbitrage && lastStake === 'stake1') {
            const stake2 = (stake1 * value1 / value2)
            setStake2(roundDigits(stake2))
            if (stake1 === '') {
                setStake2('')
            }
        }
    }, [stake1])

    useEffect(() => {
        const arbitrage = arbitrages.find(e => e.group_key === selected)
        if (linked && arbitrage && lastStake === 'stake2') {
            const stake1 = (stake2 * value2 / value1)
            setStake1(roundDigits(stake1))
            if (stake2 === '') {
                setStake1('')
            }
        }
    }, [stake2])

    useEffect(() => {
        if (showAccounts === 'false') {
            setCookie('showAccount', false)
        } else {
            setCookie('showAccount', true)
        }
    }, [showAccounts])

    // useEffect(() => {
    //     if (!getCookie("openModal")) {
    //         cookie.set('openModal', 'false', {
    //             expires: 0.001
    //         })
    //     }
    // })


    if (dataFetched) {
        const parameters = { arbitrages, free, unpaidInvoices, selected, setSelected, userMessage, values, membership_type, trial_end, invoices }
        return (
            <Layout>
                {/* {!getCookie("openModal") && */}
                <>
                    <Modal
                        onHide={() => cookie.set('openModal', 'false', { expires: 0.5 })}
                        show={(!getCookie("openModal") && free)}
                        // size="xl"
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                        className="placeholder-color-white"
                    // style={{ '--bs-modal-width': '100%', '--bs-modal-bg': '#222', '--bs-body-bg': '#222', '--bs-body-color': '#fff', '--bs-border-color': '#616161' }}
                    >
                        <Modal.Header closeButton style={{ 'border': 'none' }} className="text-dark">
                            <Modal.Title id="contained-modal-title-vcenter">
                                Odomknite Plný Potenciál Zisku!
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={{}}>
                            <p className='lead'>Vidíte len špičku ľadovca.</p>
                            <p>S našou plnou verziou získate prístup ku <strong>všetkým arbitrážam</strong>, vrátane tých s najvyššími ziskami, ktoré vám vo free verzii unikajú.</p>
                            <p>Prestaňte sa obmedzovať a začnite zarábať naplno ešte dnes!</p>
                            <div
                                className='btn btn-primary w-100 mt-3'
                                onClick={() => navigate('/pricing')}
                            >
                                Zobraziť Cenník
                            </div>
                        </Modal.Body>
                    </Modal>
                </>
                {/* } */}
                <ToastContainer />
                <div className="overflow-auto container-fluid text-white font2 " style={{ "minHeight": "calc(100vh - 56px)", "background": "#161616" }} >
                    {window.innerWidth <= 950
                        ? <SmallScreen parameters={parameters} />
                        : <BigScreen parameters={parameters} />
                    }
                </div>

            </Layout>
        )
    } else {
        return (
            <Layout>
                <div className="container d-flex align-items-center justify-content-center" style={{ "height": "calc(100vh - 56px)" }}>
                    <ClipLoader size={30} margin={5} speedMultiplier={1} color={"#fff"} />
                </div>
            </Layout>
        )
    }
}

export default PrematchArbitrage